/**
 * Firebase Application
 */

// Dependencies
import path from 'path'
import Firebase from 'firebase'
import config from '@config/app.json'

// Init Firebase
Firebase.initializeApp(config.firebase)

/**
 * Automatically format and append data for firebase input
 * @param  {object} data
 * @return {object}
 */
const prepIn = (data, timestamp = true) => {
	if (timestamp) {
		if (data.createdAt) {
			data.updatedAt = Firebase.database.ServerValue.TIMESTAMP
		} else {
			data.createdAt = Firebase.database.ServerValue.TIMESTAMP
		}
	}

	const res = {}
	for (const key in data) {
		if (key.indexOf('$') !== 0) {
			if (data[key] && typeof data[key] === 'object') {
				res[key] = prepIn(data[key], false)
			} else {
				res[key] = data[key]
			}
		}
	}

	if (data.$priority || data['.priority']) {
		res['.priority'] = data.$priority || data['.priority']
	}

	delete res['.key']

	return res
}

const newID = (function () {
	// Modeled after base64 web-safe chars, but ordered by ASCII.
	const PUSH_CHARS = '-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz'

	// Timestamp of last push, used to prevent local collisions if you push twice in one ms.
	let lastPushTime = 0

	// We generate 72-bits of randomness which get turned into 12 characters and appended to the
	// timestamp to prevent collisions with other clients.  We store the last characters we
	// generated because in the event of a collision, we'll use those same characters except
	// "incremented" by one.
	const lastRandChars = []

	return function () {
		let now = new Date().getTime()
		const duplicateTime = (now === lastPushTime)
		lastPushTime = now

		const timeStampChars = new Array(8)
		for (let i = 7; i >= 0; i--) {
			timeStampChars[i] = PUSH_CHARS.charAt(now % 64)
			// NOTE: Can't use << here because javascript will convert to int and lose the upper bits.
			now = Math.floor(now / 64)
		}
		if (now !== 0) throw new Error('We should have converted the entire timestamp.')

		let id = timeStampChars.join('')

		if (duplicateTime) {
			// If the timestamp hasn't changed since last push, use the same random number, except incremented by 1.
			let i = 11
			for (i = 11; i >= 0 && lastRandChars[i] === 63; i--) {
				lastRandChars[i] = 0
			}
			lastRandChars[i]++
		} else {
			for (let i = 0; i < 12; i++) {
				lastRandChars[i] = Math.floor(Math.random() * 64)
			}
		}
		for (let i = 0; i < 12; i++) {
			id += PUSH_CHARS.charAt(lastRandChars[i])
		}
		if (id.length !== 20) throw new Error('Length should be 20.')

		return id
	}
})()

/**
 * Build Firebase object with relevant firebase data for better references.
 * @param  {object} snap Firebase snapshot
 * @return {object}      Formatted object
 */
const _buildObject = snap => {
	const val = snap.val()
	const ref = snap.ref.toString().replace(config.firebase.databaseURL, '')
	const key = snap.key
	const priority = snap.getPriority()
	const length = snap.numChildren()

	return Object.assign(
		{},
		val,
		{
			$key: key,
			$id: key,
			$ref: ref,
			$priority: priority,
			$length: length,
		}
	)
}

/**
 * Format firebase data for output.
 * @param  {object} data Raw firebase format data
 * @return {object}
 */
const prepOut = (data, isArray) => {
	if (isArray) {
		const res = []
		data.forEach(snap => {
			res.push(_buildObject(snap))
		})
		return res
	}
	return _buildObject(data)
}

/**
 * Return firebase key from data object
 * @param  {object} data
 * @return {string}
 */
const key = data => {
	return data.$key
	// return data['.key']
}

/**
 * Return firebase path from data object
 * @param  {object} data
 * @return {string}
 */
const ref = data => {
	return data.$ref.replace(config.firebase.databaseURL, '')
}

// References
class Refs {
	constructor(siteId) {
		// this.users = path.join('users')
		this.owners = path.join('owners')

		if (siteId) {
			this.site = path.join('sites', siteId)
			this.content = path.join('content', siteId)
			this.model = path.join('model', siteId)
			this.users = path.join('users', siteId)
		}
	}
}

export default {
	auth: Firebase.auth,
	database: Firebase.database,
	storage: Firebase.storage,
	prepIn,
	prepOut,
	newID,
	key,
	refs: Refs,
	ref,
}



// WEBPACK FOOTER //
// ./src/lib/fb/index.js